import { required, confirmed,email } from "vee-validate/dist/rules";
import { extend, configure } from "vee-validate";
import i18n from '@/i18n/i18n.js'

// console.log(i18n.$t('DataInfo.Overview'))
configure({
    defaultMessage: (field, values) => {
        // override the field name.
        values._field_ = i18n.t(`fields.${field}`);
            console.log(field, values)
        return i18n.t(`validation.${values._rule_}`, values);
    }
});
// 不能为空
extend("required", {
    ...required,
    message: `${i18n.t('validation.required')}`,
    computesRequired: true
});
// 用户名长度
extend("userName", {
    validate: value => {
        var account = /^[a-zA-Z0-9_-]{4,16}$/;
        return account.test(value);
    },
    // message: "为4到16位(字母，数字，下划线，减号)"
    message:`${i18n.t('validation.userName')}`,
});
// 用户名长度
extend("min", {
    validate: value => {
        return value.length >= 5;
    },
    message: `${i18n.t('validation.min')}`
});
// 校验重复性
extend("confirmed", {
    ...confirmed,
    message: `${i18n.t('validation.confirmed')}`
});
// 邮箱格式
extend("email", {
    validate: value => {
        var emil = /[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+/;
        return emil.test(value)
    },
    message: `${i18n.t('validation.email')}`
});
// 校验验证码
extend("code", {
    validate: value => {
        return value.length == 6
    },
    message: `${i18n.t('validation.code')}`
});



